import { Selector } from 'react-redux';
import { RootState } from '../../redux/root-reducer';
import { createSelector } from 'reselect';
import { IContestRequest } from '../../redux/requests/types';

export const contestRequestsSelector: Selector<RootState, IContestRequest[]> = createSelector(
    (state: RootState) => state.requests,
    request => request.requests,
);

export const gettingUserRequests: Selector<RootState, boolean | undefined> = createSelector(
    (state: RootState) => state.requests,
    request => request.gettingRequests,
);
